import { FormattedOption } from 'types/dictionaries';

const getLabelByValue = (
  dictionary: FormattedOption[] | undefined,
  value: string
): string | null =>
  dictionary?.find((option) => option.value === value)?.label || null;

export default getLabelByValue;
